import { Input } from '@mui/material';
import React, { useState } from 'react'
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import { VscSearch } from 'react-icons/vsc';

const Search = () => {
    const [isSearchList, setSearch] = useState(false);

    const toggleSearch = () => {
        setSearch(!isSearchList);

    };
    return (
        <>
            <div className=" block top-0 sticky z-10 bottom-0  md:hidden">
                <div className="text-[1rem] py-3  bg-[#004A8B] text-white flex justify-center relative">
                    {isSearchList ? <button type='button' onClick={toggleSearch} className='  text-center  font-bold tracking-wider flex'>SEARCH LISTINGS <MdKeyboardArrowUp className='text-[1.5rem] mx-2' /></button> :
                        <button type='button' onClick={toggleSearch} className='font-bold tracking-wider flex'>SEARCH LISTINGS <MdKeyboardArrowDown className='text-[1.5rem] mx-2' /></button>}
                </div>


                <div className={`${isSearchList ? 'visible' : 'hidden'} fixed w-full bg-white z-50 py-7 px-4 bottom-[3rem]`}>
                    <div className="w-full">
                        <select name="" id="" className=' w-full  border-b-2 border-gray-200 py-3 ' >
                            <option value="" className=''>For Sale</option>
                            <option value="">Sold</option>
                        </select>
                    </div>
                    <div className="my-[1.5rem] w-full ">
                        <select name="" id="" className=' w-full  border-b-2 border-gray-200 py-3' >
                            <option value="">State</option>
                            <option value="">ACT</option>
                            <option value="">NSW</option>
                            <option value="">NT</option>
                            <option value="">QLD</option>
                            <option value="">TAS</option>
                            <option value="">VIC</option>
                            <option value="">WA</option>
                        </select>
                    </div>
                    <div className=" w-full my-[1.5rem]">
                        <Input type="text" placeholder='SUBRUB' sx={{ width: "100%" }} />
                    </div>
                    <div className="w-full my-[1.5rem] ">
                        <select name="" id="" className=' w-full  border-b-2 border-gray-200 py-3' >
                            <option value="" className=''>PROTOTTYPE TYPE</option>
                            <option value="">Cotton</option>
                            <option value="">Cropy</option>
                            <option value="">Dairy</option>
                            <option value="">Development</option>
                            <option value="">Horticulture</option>
                            <option value="">LiveStocks</option>
                        </select>
                    </div>

                    <div className=" w-full  my-[1.5rem] ">
                        <Input type="text" placeholder='MIN PRICE' sx={{ width: "100%" }} />
                    </div>
                    <div className=" w-full  py-3">
                        <Input type="text" placeholder='MAX PRICE' sx={{ width: "100%" }} />
                    </div>
                    <div className=" w-full my-[1.5rem]">
                        <Input type="text" placeholder='MIN AREA' sx={{ width: "100%" }} />
                    </div>
                    <div className=" w-full  py-3">
                        <Input type="text" placeholder='MAX AREA' sx={{ width: "100%" }} />
                    </div>

                    <div className="bg-[#004A8B] py-3 hover:bg-[#B6D0B3] text-center flex justify-center text-white w-full text-md font-black  my-4  "><button className='  flex '>SEARCH NOW <VscSearch className='text-2xl mx-5' /></button></div>


                </div>


            </div>
        </>
    )
}

export default Search
